import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Typography } from "antd";
import styled from "styled-components";

import { EnrollResultData } from "./EnrollResultData";
import { ReactComponent as AlertIcon } from "../../../../../assets/svg/alert-icon-popup.svg";
import { GRAY_500 } from "../../../../../constant/colors";
import { SupportLink } from "../utils/components";

const { Text } = Typography;

const TextStyled = styled(Text)`
  font-size: 16px;
  font-weight: 500;
  color: ${GRAY_500};
`;

const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 16px;
`;

export const DeniedResult = ({ title, denialReason, confirmationId, phoneNumber }) => {
  const { t } = useTranslation();

  const resultData =
    confirmationId && phoneNumber ? (
      getRejectedIdResultData({ phoneNumber, confirmationId })
    ) : (
      <>
        <DetailsWrapper>
          <Trans
            i18nKey="patientApplications.enroll.enroll_result.application_denied_subtitle"
            components={{
              bold: <strong />,
              span: <TextStyled />,
              denialReason: denialReason || t("patientApplications.enroll.enroll_result.unknown_denial_reason")
            }}
          />
        </DetailsWrapper>
        <SupportLink />
      </>
    );

  return <EnrollResultData icon={<AlertIcon />} title={title} content={resultData} />;
};
const getRejectedIdResultData = ({ confirmationId, phoneNumber }) => {
  return (
    <>
      <Trans
        i18nKey="patientApplications.enroll.enroll_result.application_denied_rejected_id_subtitle"
        components={{
          bold: <strong />,
          span: <TextStyled />
        }}
      />
      {confirmationId && (
        <Trans
          i18nKey="patientApplications.enroll.enroll_result.confirmation_id"
          components={{
            bold: <strong />,
            span: <TextStyled />,
            confirmationId: confirmationId
          }}
        />
      )}
      {phoneNumber && (
        <>
          <Trans
            i18nKey="patientApplications.enroll.enroll_result.more_information_required"
            components={{
              span: <TextStyled />
            }}
          />

          <Trans
            i18nKey="patientApplications.enroll.enroll_result.contact_customer_service"
            components={{
              bold: <strong />,
              span: <TextStyled />,
              phoneNumber: phoneNumber
            }}
          />
        </>
      )}
    </>
  );
};
